<template>
  <div class="cooperation-page">

    <!-- 鼠标光晕 -->
    <div class="cursor-glow" ref="cursorGlow"></div>

    <!-- =================== Hero =================== -->
    <div class="hero" ref="hero">
      <div class="orb orb--1" ref="orb1"></div>
      <div class="orb orb--2" ref="orb2"></div>
      <div class="hero__overlay"></div>

      <div class="hero__body">
        <div class="hero__badge" ref="heroBadge">
          <span class="hero__dot"></span>合作案例
        </div>
        <div class="clip-wrap">
          <h1 class="hero__title clip-inner">与每一种力量<br />共筑智慧、便捷、美好生活</h1>
        </div>
        <div class="clip-wrap" style="margin-top:.6rem;">
          <p class="hero__sub clip-inner">AND EVERY POWER · BUILD A SMART, CONVENIENT AND BETTER LIFE</p>
        </div>
        <div class="hero__actions" ref="heroActions">
          <button class="btn-primary magnetic" @click="applyShow">立即申请试用</button>
        </div>

        <!-- Hero 统计数字 -->
        <div class="hero__stats" ref="heroStats">
          <div class="hero__stat" v-for="s in heroStatData" :key="s.label">
            <div class="hero__stat-row">
              <span class="hero__stat-num" :data-target="s.num">0</span>
              <span class="hero__stat-unit">{{ s.unit }}</span>
            </div>
            <p class="hero__stat-label">{{ s.label }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- =================== 案例列表 =================== -->
    <div class="cases-section">
      <div class="sec__inner">
        <div class="sec__head" ref="secHead">
          <span class="sec__label">COOPERATION CASES</span>
          <div class="title-mask">
            <h2 class="title-mask__inner sec__title">合作案例</h2>
          </div>
          <p class="sec__desc" ref="secDesc">覆盖 K12、高校、企业、园区等多种场景，深度赋能餐饮数字化</p>
        </div>
      </div>

      <div class="case-list">
        <div
          v-for="(item, index) in caseData"
          :key="index"
          class="case-card"
          :class="{ 'case-card--rev': item.type === '1' }"
          ref="caseCards"
        >
          <!-- 图片区 -->
          <div class="case-card__img-wrap">
            <div class="case-card__img">
              <img :src="item.img" :alt="item.title" />
              <!-- 图片渐变蒙层 -->
              <div class="case-card__img-mask"></div>
            </div>
            <!-- 浮在图片上的场景标 -->
            <span class="case-card__scene">{{ item.category }}</span>
          </div>

          <!-- 内容区 -->
          <div class="case-card__body">
            <!-- 大号背景序号 -->
            <span class="case-card__bg-num" aria-hidden="true">{{ String(index + 1).padStart(2, '0') }}</span>

            <div class="case-card__top">
              <span class="case-card__chip">{{ item.category }}</span>
            </div>

            <h3 class="case-card__title">{{ item.title }}</h3>

            <div class="case-card__bar"></div>

            <p class="case-card__desc">{{ item.content }}</p>

            <!-- 功能标签 -->
            <div class="case-card__tags">
              <span
                v-for="tag in item.tags"
                :key="tag"
                class="feat-tag"
              >{{ tag }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ApplyDialog :show.sync="show"></ApplyDialog>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ApplyDialog from '../components/applyDialog.vue'

gsap.registerPlugin(ScrollTrigger)

export default {
  components: { ApplyDialog },
  data() {
    return {
      show: false,
      heroStatData: [
        { num: 5,    unit: '+',   label: '覆盖场景' },
        { num: 500,  unit: '+',   label: '合作商户' },
        { num: 1000, unit: '万+', label: '日处理交易' },
      ],
      caseData: [
        {
          img: require('../assets/cooperation1.png'),
          title: 'K12',
          category: '中小学教育',
          content: '家长线上充值，学生刷卡、刷脸就餐。用餐数据可视化，结合菜品销售数据制定菜谱，数据全流程监控，便于食堂高效管理和决策分析。',
          type: '0',
          tags: ['家校互联', '刷脸就餐', '菜品可视化', '全程数据监控'],
        },
        {
          img: require('../assets/cooperation2.png'),
          title: '高校',
          category: '大学校园',
          content: '线上充值，刷卡、刷脸、扫码就餐，实时获取消费信息掌握消费情况。为食堂管理者提供食堂运营的数据支撑。',
          type: '1',
          tags: ['多端充值', '刷脸/扫码', '实时消费推送', '运营数据'],
        },
        {
          img: require('../assets/cooperation3.png'),
          title: '企业、政府',
          category: '企业/政府',
          content: '多种就餐模式，包括在线预订、餐柜取餐等。支持餐补结算，为食堂管理者提供食堂运营的数据支撑。',
          type: '0',
          tags: ['在线预订', '餐补结算', '餐柜取餐', '多模式管控'],
        },
        {
          img: require('../assets/cooperation4.png'),
          title: '园区',
          category: '产业园区',
          content: '聚合支付避免漏单，食堂合理备餐减少浪费，智能对账及时结算，员工就餐数据可视化，个性化服务提升满意度。',
          type: '1',
          tags: ['聚合支付', '智能对账', '减少浪费', '数据可视化'],
        },
        {
          img: require('../assets/cooperation5.png'),
          title: '其他场景',
          category: '多元场景',
          content: '团餐、养老院、医院、其他快餐、轻餐等，灵活适配各类餐饮运营需求，一体化数字解决方案，助力多行业降本增效。',
          type: '0',
          tags: ['团餐', '养老院', '医院', '快餐/轻餐'],
        },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this._initCursorGlow()
      this._initHeroAnimations()
      this._initSectionHead()
      this._initCaseCards()
      this._initMagnetic()
    })
  },

  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill())
    document.removeEventListener('mousemove', this._cursorHandler)
  },

  methods: {
    /* ─── 鼠标光晕 ─── */
    _initCursorGlow() {
      const glow = this.$refs.cursorGlow
      if (!glow) return
      this._cursorHandler = (e) => {
        gsap.to(glow, { x: e.clientX, y: e.clientY, duration: 0.6, ease: 'power2.out' })
      }
      document.addEventListener('mousemove', this._cursorHandler)
    },

    /* ─── Hero 入场 ─── */
    _initHeroAnimations() {
      const tl = gsap.timeline({ delay: 0.2 })

      /* 光球浮动 */
      if (this.$refs.orb1) gsap.to(this.$refs.orb1, { y: -50, x: 25, duration: 5, repeat: -1, yoyo: true, ease: 'sine.inOut' })
      if (this.$refs.orb2) gsap.to(this.$refs.orb2, { y: 40, x: -30, duration: 6, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1 })

      /* Hero 文字序列 */
      tl.from(this.$refs.heroBadge, { scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(2)' })
        .from('.clip-inner', { yPercent: 105, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.18 }, '-=0.2')
        .from(this.$refs.heroActions?.children || [], { y: 24, opacity: 0, duration: 0.5, ease: 'power3.out', stagger: 0.1 }, '-=0.4')
        .from(this.$refs.heroStats?.children || [], { y: 20, opacity: 0, duration: 0.5, ease: 'power3.out', stagger: 0.08 }, '-=0.3')

      /* 统计数字计数 */
      this.$el.querySelectorAll('.hero__stat-num').forEach((el) => {
        const target = parseInt(el.dataset.target, 10)
        gsap.fromTo(el, { innerHTML: 0 }, {
          innerHTML: target, duration: 2, ease: 'power2.out',
          snap: { innerHTML: 1 }, delay: 1.2,
        })
      })

      /* 光球视差 */
      gsap.to(this.$refs.orb1, { y: -100, ease: 'none',
        scrollTrigger: { trigger: this.$refs.hero, scrub: 1, start: 'top top', end: 'bottom top' } })
    },

    /* ─── Section 标题揭示 ─── */
    _initSectionHead() {
      const label = this.$el.querySelector('.sec__label')
      const titleInner = this.$el.querySelector('.title-mask__inner')
      const desc = this.$refs.secDesc

      if (label) {
        gsap.fromTo(label, { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: label, start: 'top 88%', once: true }, clearProps: 'transform,opacity' })
      }
      if (titleInner) {
        gsap.fromTo(titleInner, { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: titleInner, start: 'top 88%', once: true }, clearProps: 'transform' })
      }
      if (desc) {
        gsap.fromTo(desc, { y: 16, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', delay: 0.3,
            scrollTrigger: { trigger: desc, start: 'top 90%', once: true }, clearProps: 'transform,opacity' })
      }
    },

    /* ─── 案例卡片：左右交替 scrub 滑入 + 图片视差 ─── */
    _initCaseCards() {
      const cards = Array.from(this.$el.querySelectorAll('.case-card'))
      cards.forEach((card, i) => {
        const isRev = card.classList.contains('case-card--rev')

        /* 卡片整体滑入（scrub，左右交替） */
        gsap.fromTo(card,
          { x: isRev ? 100 : -100, opacity: 0 },
          {
            x: 0, opacity: 1, ease: 'none',
            scrollTrigger: {
              trigger: card, start: 'top 85%', end: 'top 50%', scrub: 0.7,
            },
            clearProps: 'transform,opacity',
          }
        )

        /* 图片内部视差 */
        const img = card.querySelector('.case-card__img img')
        if (img) {
          gsap.to(img, {
            yPercent: -12, ease: 'none',
            scrollTrigger: { trigger: card, scrub: 1.2, start: 'top bottom', end: 'bottom top' },
          })
        }

        /* 功能标签逐个弹入 */
        const tags = Array.from(card.querySelectorAll('.feat-tag'))
        if (tags.length) {
          gsap.fromTo(tags,
            { scale: 0, opacity: 0 },
            {
              scale: 1, opacity: 1, duration: 0.4, ease: 'back.out(1.8)', stagger: 0.06,
              scrollTrigger: { trigger: card, start: 'top 65%', once: true },
              clearProps: 'transform,opacity',
            }
          )
        }
      })
    },

    /* ─── 磁性按钮 ─── */
    _initMagnetic() {
      this.$el.querySelectorAll('.magnetic').forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const r = btn.getBoundingClientRect()
          gsap.to(btn, { x: (e.clientX - r.left - r.width / 2) * 0.35, y: (e.clientY - r.top - r.height / 2) * 0.35, duration: 0.3, ease: 'power2.out' })
        })
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.5)' })
        })
      })
    },

    /** 弹出申请试用弹窗 */
    applyShow() {
      this.show = true
      this.noScroll()
    },
  },
}
</script>

<style lang="scss" scoped>
$blue:   #0E6EB8;
$blue-l: #38A0F5;
$dark:   #0D1B2E;
$tint:   #F0F7FF;
$muted:  #6B7280;
$r-xl:   1.25rem;
$tr:     all .3s cubic-bezier(.4,0,.2,1);

/* ─── 鼠标光晕 ─── */
.cursor-glow {
  position: fixed; width: 28rem; height: 28rem; border-radius: 50%;
  background: radial-gradient(circle, rgba(14,110,184,.1), transparent 70%);
  pointer-events: none; transform: translate(-50%,-50%); z-index: 9990;
  mix-blend-mode: screen; will-change: transform;
}

/* ─── Hero ─── */
.hero {
  height: 44rem;
  background: url('../assets/cooperation6.png') no-repeat center center / cover;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;

  .orb {
    position: absolute; border-radius: 50%; filter: blur(90px);
    pointer-events: none; z-index: 1; will-change: transform;
  }
  .orb--1 { width: 38rem; height: 38rem; background: rgba(14,110,184,.3); top: -10rem; right: -4rem; }
  .orb--2 { width: 24rem; height: 24rem; background: rgba(56,160,245,.2); bottom: 2rem; left: 38%; }

  &__overlay {
    position: absolute; inset: 0; z-index: 1;
    background: linear-gradient(110deg, rgba(8,28,60,.82) 0%, rgba(14,110,184,.4) 55%, rgba(0,0,0,.08) 100%);
  }

  &__body { position: relative; z-index: 3; padding: 0 7.5rem; max-width: 56%; }

  &__badge {
    display: inline-flex; align-items: center; gap: .5rem;
    background: rgba(255,255,255,.12); backdrop-filter: blur(12px);
    border: 1px solid rgba(255,255,255,.25); color: #fff;
    font-size: .78rem; font-weight: 600; letter-spacing: .08em;
    padding: .38rem .95rem; border-radius: 5rem; margin-bottom: 1.2rem;
  }
  &__dot {
    width: .45rem; height: .45rem; border-radius: 50%;
    background: $blue-l; animation: pulse 2s infinite;
  }
  &__title {
    font-size: 2.5rem; font-weight: 800; color: #fff;
    line-height: 1.4; margin: 0 0 .6rem;
    text-shadow: 0 2px 20px rgba(0,0,0,.35);
  }
  &__sub {
    font-size: .78rem; color: rgba(255,255,255,.7);
    letter-spacing: .06em; margin: 0 0 2rem;
  }
  &__actions { display: flex; gap: 1rem; margin-bottom: 2.5rem; }

  /* 统计数字横排 */
  &__stats {
    display: flex; gap: 3rem; align-items: center;
    padding-top: 2rem;
    border-top: 1px solid rgba(255,255,255,.15);
  }
  &__stat-row { display: flex; align-items: baseline; gap: .2rem; margin-bottom: .25rem; }
  &__stat-num  { font-size: 2rem; font-weight: 900; color: #fff; line-height: 1; }
  &__stat-unit { font-size: .9rem; font-weight: 700; color: $blue-l; }
  &__stat-label { font-size: .75rem; color: rgba(255,255,255,.55); letter-spacing: .06em; }
}

/* clip-path 遮幕 */
.clip-wrap { overflow: hidden; line-height: 1; }
.clip-inner { display: block; }

/* ─── 按钮 ─── */
.btn-primary {
  padding: .9rem 2.4rem;
  background: linear-gradient(135deg, $blue, $blue-l);
  color: #fff; font-size: .95rem; font-weight: 700;
  border-radius: 3rem; border: none; cursor: pointer;
  box-shadow: 0 6px 20px rgba(14,110,184,.4); transition: $tr; will-change: transform;
  &:hover { box-shadow: 0 10px 30px rgba(14,110,184,.55); }
}

/* ─── Section ─── */
.cases-section { background: #fff; padding-bottom: 6rem; }

.sec__inner { max-width: 1400px; margin: 0 auto; padding: 0 7.5rem; }

.sec__head {
  text-align: center; padding: 5rem 0 4rem;
}
.sec__label {
  display: inline-block; font-size: .72rem; font-weight: 700;
  letter-spacing: .2em; color: $blue; background: rgba(14,110,184,.09);
  padding: .3rem .9rem; border-radius: 5rem; margin-bottom: .8rem;
}
.title-mask { overflow: hidden; margin-bottom: .7rem; }
.title-mask__inner {
  display: block; font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0;
}
.sec__title { font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0 0 .7rem; }
.sec__desc { font-size: .95rem; color: $muted; margin: 0; }

/* ─── 案例列表 ─── */
.case-list {
  display: flex; flex-direction: column; gap: 0;
  max-width: 1400px; margin: 0 auto; padding: 0 7.5rem;
}

/* ─── 单张案例卡片 ─── */
.case-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 0;
  min-height: 32rem;
  overflow: hidden;
  position: relative;

  /* 奇数卡片：浅灰底 */
  &:nth-child(odd)  { background: $tint; }
  &:nth-child(even) { background: #fff; }

  /* 翻转列顺序 */
  &--rev { direction: rtl;
    .case-card__img-wrap,
    .case-card__body { direction: ltr; }
  }

  &:hover {
    .case-card__img img { transform: scale(1.06) translateY(-2%); }
    .case-card__bar { transform: scaleX(1.6); }
  }

  /* 图片侧 */
  &__img-wrap {
    position: relative;
    height: 100%;
    overflow: hidden;
  }
  &__img {
    width: 100%; height: 100%;
    overflow: hidden;

    img {
      width: 100%; height: 100%;
      object-fit: cover;
      transition: transform .65s cubic-bezier(.4,0,.2,1);
      will-change: transform;
    }
  }
  &__img-mask {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(14,110,184,.25), transparent 60%);
    pointer-events: none;
  }
  &__scene {
    position: absolute; top: 1.5rem; left: 1.5rem; z-index: 2;
    background: rgba(14,110,184,.85); backdrop-filter: blur(10px);
    color: #fff; font-size: .72rem; font-weight: 700; letter-spacing: .08em;
    padding: .3rem .9rem; border-radius: 5rem;
    border: 1px solid rgba(255,255,255,.25);
  }

  /* 内容侧 */
  &__body {
    position: relative;
    padding: 3.5rem 4rem;
    overflow: hidden;
  }

  /* 背景大序号 */
  &__bg-num {
    position: absolute; top: 1rem; right: 2rem;
    font-size: 9rem; font-weight: 900; line-height: 1;
    color: rgba(14,110,184,.06);
    pointer-events: none;
    letter-spacing: -.05em;
    user-select: none;
  }

  &__top { margin-bottom: 1rem; }
  &__chip {
    display: inline-block;
    font-size: .72rem; font-weight: 700; letter-spacing: .1em;
    color: $blue; background: rgba(14,110,184,.1);
    padding: .25rem .75rem; border-radius: 5rem;
  }

  &__title {
    font-size: 2.2rem; font-weight: 900; color: #1A2535;
    margin: 0 0 1.25rem; line-height: 1.2;
  }

  &__bar {
    width: 3rem; height: 4px;
    background: linear-gradient(90deg, $blue, $blue-l);
    border-radius: 3px; margin-bottom: 1.5rem;
    transform-origin: left;
    transition: transform .4s ease;
  }

  &__desc {
    font-size: .9rem; color: $muted;
    line-height: 1.85; margin: 0 0 2rem;
    max-width: 32rem;
  }

  &__tags { display: flex; flex-wrap: wrap; gap: .5rem; }
}

/* 功能标签 */
.feat-tag {
  display: inline-flex; align-items: center;
  font-size: .75rem; font-weight: 600; color: $blue;
  background: rgba(14,110,184,.08);
  border: 1px solid rgba(14,110,184,.18);
  padding: .3rem .85rem; border-radius: 5rem;
  transition: $tr;
  will-change: transform;

  &:hover {
    background: $blue; color: #fff;
    border-color: $blue;
    transform: translateY(-2px);
  }
}

/* ─── Keyframes ─── */
@keyframes pulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50%      { opacity: .5; transform: scale(1.4); }
}
</style>

<style>
@media screen and (max-width: 600px) {
  .cursor-glow { display: none; }
  .cooperation-page .hero { margin-top: 70px; min-height: 30rem; height: auto !important; padding: 3rem 0; }
  .hero__body { padding: 0 1.5rem !important; max-width: 100% !important; }
  .case-list { padding: 0 1.5rem !important; }
  .case-card { grid-template-columns: 1fr !important; direction: ltr !important; }
  .case-card__img-wrap { height: 14rem; }
  .case-card__body { padding: 2rem 1.5rem !important; }
  .case-card__bg-num { font-size: 5rem !important; }
  .case-card__title { font-size: 1.5rem !important; }
  .sec__inner { padding: 0 1.5rem !important; }
  .hero__stats { gap: 1.5rem !important; flex-wrap: wrap; }
}
</style>
